import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

function App() {
  let pjson = require('../package.json');
  return (
    <div className="App">
        <SwaggerUI url="docs/api/openapi.yaml" />
        <p id="footer">Version: { pjson.version }</p>
    </div>
  );
}

export default App;
